import { JSX } from 'react';
import atDivider from './at-divider.variants';
import classNames from 'classnames';
import {
  EDividerColors,
  EDividerDirectionalVariants,
  IAtDividerProps,
} from './at-divider.types';

/**
 * `AtDivider` is a presentational horizontal or vertical rule used to visually separate content.
 *
 * Often used in layouts, footers, and CMS-authored blocks to create structured visual hierarchy.
 * Includes support for direction, color theming, stylistic intent, and ARIA accessibility.
 *
 */

export const AtDivider = ({
  color = EDividerColors.GREY,
  intent,
  direction = EDividerDirectionalVariants.HORIZONTAL,
  customClasses,
  decorative = false,
}: IAtDividerProps): JSX.Element => {
  // specifically used for horizontal bars authored in CMS. See 0.6.2 in figma
  const variantClasses = atDivider({
    intent,
    direction,
    color,
  });
  return (
    <hr
      aria-hidden={decorative}
      className={classNames([variantClasses, customClasses])}
    />
  );
};
